import { Component, EventEmitter, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { HANDLED_COURRIER } from '../display-document.component';
import { DisplayContentData, GEDViewerComponent } from '../gedviewer/gedviewer.component';

const MAX_WIDTH = 50; // Représente la largeur que l'on veut donner au visualisateur de PDF dans l'iframe
const MAX_HEIGHT = 70;  // Représente la hauteur que l'on veut donner au visualisateur de PDF dans l'iframe

interface IframeDimensions {
  height: number;
  width: number;
}

@Component({
  selector: 'app-courrier-content-viewer',
  templateUrl: './courrier-content-viewer.component.html',
  styleUrls: ['./courrier-content-viewer.component.scss']
})
export class CourrierContentViewerComponent extends GEDViewerComponent implements OnDestroy {

  private _iframeDimensions: IframeDimensions = {
    height: 0,
    width: 0
  };

  public isCourrierOrOrdonnance: boolean = false;

  public get iframeDimensions(): IframeDimensions {
    return this._iframeDimensions;
  }

  public set iframeDimensions(dimensions: IframeDimensions) {
    this._iframeDimensions = dimensions;
  }

  private _originalTitle: string;
  private iframeAlreadyLoaded = false;

  public displayedDocument = new EventEmitter<void>()

  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.calcIframeDimensions();
  }

  constructor(
    private _courrier: CourriersService,
    protected domSanitizer: DomSanitizer
  ) {
    super(domSanitizer);
    this.calcIframeDimensions();
  }

  ngOnDestroy () {
    const titleTag = document.head?.getElementsByTagName('title')?.[0];
    if (this._originalTitle && titleTag) {
      titleTag.text = this._originalTitle;
    }
  }

  public async setData(data: DisplayContentData): Promise<void> {
    if(data.contentType === HANDLED_COURRIER[0] || data.contentType === HANDLED_COURRIER[1] || data.contentType === HANDLED_COURRIER[2]) {
      this.isCourrierOrOrdonnance =true;
    }
    setTimeout(() => {
      this._data = data;
      //on ne sanitize pas ici avec domPurifier, car on le fait en amont pour ne pas casser la mise en page
      this._data.data = this.domSanitizer.bypassSecurityTrustHtml(data.data) as string;
      this._data.dataPrint = this.domSanitizer.bypassSecurityTrustHtml(data.dataPrint) as string;
    }, 0);
  }

  public calcIframeDimensions(): void {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    this.iframeDimensions = {
      height: vh * MAX_HEIGHT / 100,
      width: vw * MAX_WIDTH / 100
    };
  }

  public print(displayDocument: DisplayContentData): void {
    if (displayDocument.contentType === HANDLED_COURRIER[0]) {
      this._courrier.print(displayDocument.id);
    }

    let iframe : Window;
    if (displayDocument.isPagedJSActive && this.isCourrierOrOrdonnance === false) {
      iframe = window.frames['quill-iframe'] as Window;
    }else if(this.isCourrierOrOrdonnance === true){
      iframe = window.frames['quill-iframe-courrier'] as Window;
    }else {
      iframe = window.frames['quill-iframe-hidden'] as Window;
    }
    const titleTag = document.head?.getElementsByTagName('title')?.[0];
    if (titleTag) {
      this._originalTitle = titleTag.text
      titleTag.text = displayDocument.title;
    }
    iframe.print();
  }

  onIframeLoaded(event?: Event): void {
    if (event && event.target) {
      const iframe = event.target as HTMLIFrameElement;
      if (iframe.contentDocument) {
        iframe.contentDocument.addEventListener('click', (e) => {
          const target = e.target as HTMLElement;
          if (target.closest('a')) {
            e.preventDefault();
          }
        });
      }
    }

    if (this.iframeAlreadyLoaded) {
      return; // ignore les autres "load"
    }
    this.iframeAlreadyLoaded = true;
    this.displayedDocument.emit();
  }
}
